// The UI string areas (i18n/areas/*.ts, each `export const area = defineArea(…)`; area.ts), collected
// with import.meta.glob. fi.ts and en.ts add them to the core strings. A key declared twice is an error.
import type { Area, AreaMessages } from './area';

const AREA_FILES = import.meta.glob<{ area?: Area }>('./areas/*.ts', { eager: true });

function collect(lang: 'fi' | 'en'): AreaMessages {
  const out: Record<string, unknown> = {};
  for (const [file, m] of Object.entries(AREA_FILES)) {
    if (!m.area) continue;
    if (Object.prototype.hasOwnProperty.call(out, m.area.key)) throw new Error(`i18n area ${m.area.key} is declared twice (${file})`);
    out[m.area.key] = m.area[lang];
  }
  return out as unknown as AreaMessages;
}

export const areasFi: AreaMessages = collect('fi');
export const areasEn: AreaMessages = collect('en');
